import "../App.scss";
import type { ITitleText, ILatestUpdatedFiles, ILatestUpdatedPages } from "InterfacesTypes/interfaces";
import { useSelector } from "react-redux";
import { selectRecentlyUpdatedFiles, selectRecentlyUpdatedPages, selectTitleTexts } from "state/selectors/Selectors";
import { useEffect, useState } from "react";
import Breadcrumbs from "components/breadcrumbs/Breadcrumbs";
import TitleComponent from "components/TitleComponent";
import BannerImageCarousel from "components/BannerImageCarousel";
import Navigation from "components/navigation/Navigation";
import { STARTPAGETITLES } from "InterfacesTypes/enums";
import { useParams } from "react-router-dom";

const RecentlyUpdatedFiles = () => {

    const sliceValue = 50;

    const { type } = useParams();
    const files: ILatestUpdatedFiles[] = useSelector(selectRecentlyUpdatedFiles);
    const pages: ILatestUpdatedPages[] = useSelector(selectRecentlyUpdatedPages);
    const titleTexts: ITitleText[] = useSelector(selectTitleTexts);
    const [filteredFiles, setFilteredFiles] = useState<ILatestUpdatedFiles[]>(files.slice(0, sliceValue));
    const [filteredPages, setFilteredPages] = useState<ILatestUpdatedPages[]>(pages.slice(0, sliceValue));
    const [filter, setFilter] = useState<string>("");
    const [filterOptions, setFilterOptions] = useState<string[]>([]);

    useEffect(() => {
        if (type === "files") {
            const uniqueFileSiteTitles = Array.from(
                new Set(
                    files.map(x => x.SiteTitle)
                        .filter((b): b is string => typeof b === "string")
                )
            );
            setFilterOptions(uniqueFileSiteTitles)
        }
    }, [files, type])

    useEffect(() => {
        if (type === "pages") {
            const uniquePageSiteTitles = Array.from(
                new Set(
                    pages.map(x => x.SiteTitle)
                        .filter((b): b is string => typeof b === "string")
                )
            );
            setFilterOptions(uniquePageSiteTitles)
        }
    }, [pages, type])

    useEffect(() => {
        if (filter === "") {
            if (type === "files") {
                setFilteredFiles(files.slice(0, sliceValue));
            } else if (type === "pages") {
                setFilteredPages(pages.slice(0, sliceValue));
            }
        } else if (filter === "noIE" && type === "files") {
            setFilteredFiles(files.filter(x => x.SiteTitle !== "Internationell Spedition").slice(0, 50));
        } else {
            if (type === "files") {
                const filteredFiles = files.filter(x => x.SiteTitle === filter);
                setFilteredFiles(filteredFiles.slice(0, sliceValue));
            } else if (type === "pages") {
                const filteredPages = pages.filter(x => x.SiteTitle === filter);
                setFilteredPages(filteredPages.slice(0, sliceValue));
            }
        }
    }, [files, filter, pages, type])

    const title = type === "files" ?
        titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.RECENT_UPDATED_FILES_PAGE_TITLE) :
        titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.RECENT_UPDATED_PAGES_PAGE_TITLE);

    return (
        <div className="app-container !max-w-[1280px] min-h-[100%]">
            <BannerImageCarousel />
            <div className="bg-[rgba(33,37,41,1)] flex items-center justify-center">
                <Navigation />
            </div>
            <div className="pl-[40px] pr-[40px]">
                <div className="!pl-2 !mt-2">

                    <Breadcrumbs
                        page="RecentFiles"
                    />
                </div>
                <div>
                    <TitleComponent
                        title={title?.Title ?? "Titel saknas"}
                    />
                </div>
                <div className="justify-start items-center">
                    <p className="!text-[rgb(44,43,43)] text-lg !font-normal !pr-0 !mr-0">
                        {title?.Description ?? "Beskrivning saknas"}
                    </p>
                </div>
                <div className="flex mb-2">
                    <div className="
                                        p-2
                                        rounded-lg
                                        flex 
                                        no-underline
                                        bg-[rgba(255,255,255,0.21)] rounded-[16px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] 
                                        border border-white/53 
                                        my-[10px]
                                        ">
                        {/* items-center flex ml-[20px] */}
                        <div className="
                                            flex
                                            pt-[4px]
                                            pb-[4px]
                                            pl-[16px]
                                            pr-[16px]
                                            relative isolate rounded-[8px]
                                            border! border-[rgba(255,255,255,0.18)]
                                            !shadow-[0_10px_20px_rgba(0,0,0,0.25),inset_0_1px_0_rgba(255,255,255,0.12)]
                                            items-center
                                            text-base
                                            ">
                            <label htmlFor="filterSelect" className="pr-[10px]" >Filter:</label>
                            <select id="filterSelect" className="    
                            border-0
                            bg-transparent
                            focus:outline-none
                            focus-visible:ring-2
                            focus-visible:ring-gray-300
                            rounded-sm
                            "
                                onChange={(e) => setFilter(e.target.value)}>
                                <option value={""}>Alla</option>
                                {/* <option value={"noIE"}>Alla utom Internationell Spedition</option> */}
                                {filterOptions.map(option => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className="
                        p-2
                    flex 
                    flex-col 
                    no-underline
                    bg-[rgba(255,255,255,0.21)] rounded-[16px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] 
                    border border-white/53 
                    "
                    >
                        <div
                            className="
                        flex
                        p-[15px]
                        relative isolate rounded-[16px]
                        border! border-[rgba(255,255,255,0.18)]
                        !shadow-[0_10px_20px_rgba(0,0,0,0.25),inset_0_1px_0_rgba(255,255,255,0.12)]
                        
                        "
                        >
                            <div className="flex-1 min-w-0">
                                {type === "files" &&
                                    <table className="w-full table-fixed border-separate border-spacing-y-4">
                                        <thead className="text-black! text-lg">
                                            <tr>
                                                <th className="[@media(max-width:699px)]:hidden w-[15%]">Område</th>
                                                <th className="">Filnamn</th>
                                                <th className="[@media(max-width:799px)]:hidden whitespace-nowrap pr-4! w-[15%]">Filtyp</th>
                                                <th className="w-[100px] whitespace-nowrap">Uppdaterad</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-black! text-base">
                                            {filteredFiles.map(file => (
                                                <tr
                                                    key={file.Link}
                                                    className="
                                            hover:bg-gray-100
                                            hover: cursor-pointer
                                            ">
                                                    <td className="[@media(max-width:699px)]:hidden whitespace-nowrap truncate px-1 py-1">{file.SiteTitle}</td>
                                                    <td className="px-1 truncate">
                                                        <a href={file.Link} className="no-underline! truncate">
                                                            {file.Title}
                                                        </a>
                                                    </td>
                                                    <td className="[@media(max-width:799px)]:hidden whitespace-nowrap px-1">{file.Filetype}</td>
                                                    <td className="whitespace-nowrap px-1">{new Date(file.Date ?? "").toLocaleDateString("sv-SE")}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                }
                                {type === "pages" &&
                                    <table className="w-full table-fixed border-separate border-spacing-y-4">
                                        <thead className="text-black! text-lg">
                                            <tr>
                                                <th className="[@media(max-width:699px)]:hidden w-[15%]">Område</th>
                                                <th className="">Titeln på sidan</th>
                                                <th className="w-[200px] whitespace-nowrap">Uppdaterad</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-black! text-base">
                                            {filteredPages.map(page => (
                                                <tr
                                                    key={page.OriginalPath}
                                                    className="
                                            hover:bg-gray-100
                                            hover: cursor-pointer
                                            ">
                                                    <td className="[@media(max-width:699px)]:hidden whitespace-nowrap truncate px-1 py-1">{page.SiteTitle}</td>
                                                    <td className="whitespace-nowrap truncate px-1 py-1">
                                                        <a href={page.OriginalPath} className="no-underline! truncate">
                                                            {page.Title}
                                                        </a>
                                                    </td>
                                                    {/* <td className="whitespace-nowrap truncate px-1 py-1">{new Date(page.Write ?? "").toLocaleDateString("sv-SE")}</td> */}
                                                    <td className="whitespace-nowrap truncate px-1 py-1">{new Date(page.Write ?? "").toLocaleString("sv-SE", { dateStyle: "short", timeStyle: "short" })}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecentlyUpdatedFiles;